import FunnelCardGrid from 'containers/user/critical-elements-monitoring/components/funnel-card-grid';
import FunnelCardSkeleton from 'containers/user/critical-elements-monitoring/components/funnel-card-skeleton';
import { FUNNEL_STAGE_COUNT } from 'containers/user/critical-elements-monitoring/monitoring-constants';

const TITLE_PLACEHOLDER_WIDTH_CLASSES = [
  'w-[95px]',
  'w-[110px]',
  'w-[85px]',
  'w-[140px]',
];

export interface FunnelCardRowSkeletonProps {
  cardCount?: number;
}

const FunnelCardRowSkeleton = ({
  cardCount = FUNNEL_STAGE_COUNT,
}: FunnelCardRowSkeletonProps) => (
  <div role="status" data-testid="funnel-card-row-skeleton">
    <span className="sr-only">Loading funnel data</span>
    <div className="animate-pulse">
      <FunnelCardGrid>
        {Array.from({ length: cardCount }, (_, index) => (
          <FunnelCardSkeleton
            key={`funnel-card-skeleton-${index}`}
            titleWidthClass={
              TITLE_PLACEHOLDER_WIDTH_CLASSES[
                index % TITLE_PLACEHOLDER_WIDTH_CLASSES.length
              ]
            }
          />
        ))}
      </FunnelCardGrid>
    </div>
  </div>
);

export default FunnelCardRowSkeleton;
